import React, { forwardRef, useRef, useImperativeHandle, useState, useEffect } from "react";
import { Checkbox, TextInput } from "colbi_web_ui/lib/components/inputs";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { FORM_ACTIONS } from "../../FormActions";
import styles from "./CustomReportConfigurationForm.module.sass";
import CustomReportCondition from "../CustomReportCondition";

const CustomReportConfiguration = (props, ref) => {
    const { status, onChange, onSave, data } = props;
    const formRef = useRef();
    const { ReportName, Conditions, Metadata, ReportActive, Negation } = data || {};
    const { i18n, params } = useGlobalValue();


    // the below below variables are used to handle the negation container and its name
    const [negationName, setNegationName] = useState(Negation || "");

    useEffect(() => {
        if (Negation) {
            setNegationName(Negation);
        }
    }, [Negation]);

    const handleChange = (e, prop, value) => {
        onChange &&
            onChange({
                originalEvent: e,
                target: {
                    value: {
                        data: {
                            ...data,
                            [prop]: value,
                        },
                    },
                },
            });
    };

    useImperativeHandle(ref, () => ({
        submit: () => {
            formRef.current.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
        },
    }));

    return status !== "loading" ? (
        <form
            ref={formRef}
            onSubmit={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (formRef.current.checkValidity()) {
                    data["projectId"] = params.projectId;
                    data["Negation"] = negationName;

                    onSave && onSave();
                } else {
                    formRef.current.reportValidity();
                }
            }}
        >
            <div className={styles["group-content"]}>
                <div className={styles["flex"]}>
                    <TextInput
                        className={styles["input"]}
                        name={i18n`Report Name`}
                        placeholder={i18n`Enter a Report Name`}
                        value={ReportName || ""}
                        required
                        disabled
                    />
                    <div>
                        <h5 className={styles["label"]}>{i18n`Report active for this project?`}</h5>
                        <Checkbox
                            style={{ marginLeft: "10px", marginTop: "10px" }}
                            value={ReportActive || 0}
                            onChange={(e) => {
                                handleChange(e, "ReportActive", e.target.checked ? 1 : 0);
                            }}
                        >{i18n`Active`}</Checkbox>
                    </div>
                </div>
            </div>

            <CustomReportCondition DefaultCondition={Conditions} Metadata={Metadata} handleChange={handleChange} negationName={negationName} setNegationName={setNegationName} attributeName="Conditions" isToShowNegation={true} isToKeepOldLabes={true}/>
        </form>
    ) : null;
};

const CustomReportConfigurationRef = forwardRef(CustomReportConfiguration);

CustomReportConfigurationRef.queries = (args) => {
    return [
        args && args.ID
            ? {
                  resource: "custom_report_condition",
                  args: { id: args.ID, projectId: args.projectId, locale: args.locale },
                  body: "__typename,ID,ReportName,Conditions,ReportActive,Metadata,Negation",
              }
            : undefined,
    ].filter((q) => q);
};

CustomReportConfigurationRef.dataMapper = ["data"];

CustomReportConfigurationRef.actions = [FORM_ACTIONS.SAVE];

export default CustomReportConfigurationRef;